import { pubText, pubPath } from "../../i18n/publicTranslation";
import React from 'react';
import { PublicLanguageLinks } from './LanguageSwitcher';
import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { WEB_RELEASE_FLAGS } from '../../config/releaseFlags';

const GOLD = '#d8a363';

const FOOTER_GROUPS = [
  {
    title: 'Explore',
    links: [
      ['Stories', '/stories'],
      ['Narrators', '/narrators'],
      ['Art Styles', '/styles'],
      ['Languages', '/languages'],
      ['Moral Values', '/morals'],
      ['Musicals', '/musicals'],
      ['Custom Books', '/custom-books'],
    ],
  },
  {
    title: 'Create',
    links: [
      ['Fable Gambit', '/gambit'],
      ['Fable Go', '/create?mode=go'],
      ['Book Builder', '/book-builder'],
      ['Pricing & Plans', '/payment'],
    ],
  },
  {
    title: 'Discover',
    links: [
      ['Story Videos', '/videos/stories'],
      ['Narrator Videos', '/videos/narrators'],
      ['Blog', '/blog'],
      ['What Is an Agent Harness?', '/blog/what-is-an-agent-harness'],
      ['Create AI Story Books', '/create-story-books-with-ai'],
      ['Print Your Story', '/blog/print-your-fable-story-complete-guide'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['FAQ', '/faq'],
      ['Support', '/support'],
      ...(WEB_RELEASE_FLAGS.affiliateRewardsUiEnabled
        ? [['Affiliate Rewards', '/affiliate-program'] as const]
        : []),
      ['Privacy', '/privacy'],
      ['Terms', '/terms-of-service'],
    ],
  },
] as const;

const PublicFooter: React.FC = () => (
  <Box component="footer" sx={{ bgcolor: '#090a11', color: '#fff', textAlign: "start", borderTop: '1px solid rgba(255,255,255,.08)', py: { xs: 6, md: 7 } }}>
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 4, md: 5 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Stack direction="row" spacing={1.4} alignItems="center">
            <Box component="img" src="/fable-butterfly-gold.png?v=butterfly-20260916" alt={pubText("")} sx={{ width: 44, height: 44 }} />
            <Typography sx={{ color: GOLD, fontSize: 27, fontWeight: 900 }}>{pubText("fable")}</Typography>
          </Stack>
          <Typography sx={{ color: 'rgba(255,255,255,.58)', lineHeight: 1.7, mt: 2, maxWidth: 360 }}>{pubText(
            " Create illustrated stories with AI, bring them to life with narration and music, and print the ones you love. "
          )}</Typography>
        </Grid>
        {pubText(FOOTER_GROUPS.map((group) => (
          <Grid size={{ xs: 6, sm: 3, md: 2 }} key={group.title}>
            <Typography sx={{ fontWeight: 900, fontSize: 14, mb: 1.7 }}>{pubText(group.title)}</Typography>
            <Stack spacing={1.05}>
              {pubText(group.links.map(([label, href]) => (
                <Box
                  key={href}
                  component={RouterLink}
                  to={pubPath(href)}
                  sx={{ color: 'rgba(255,255,255,.58)', textDecoration: 'none', fontSize: 13, lineHeight: 1.4, '&:hover': { color: GOLD } }}
                >
                  {pubText(label)}
                </Box>
              )))}
            </Stack>
          </Grid>
        )))}
      </Grid>
      <PublicLanguageLinks /><Typography sx={{ color: 'rgba(255,255,255,.35)', fontSize: 13, mt: 6 }}>{pubText("Fable, 2026")}</Typography>
    </Container>
  </Box>
);

export default PublicFooter;
